module.exports = __webpack_public_path__ + "static/img/cq_tongji.2120d733.png";